var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDelivery = function SvgIconDelivery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.5,
    height: 17.963,
    viewBox: "0 0 15.5 17.963",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M14.21.763H11.967a.811.811,0,0,0-.46.145l-.2.145a4.414,4.414,0,0,1-1.36.636A2.614,2.614,0,0,0,7.5,0,2.657,2.657,0,0,0,5.037,1.69a4.414,4.414,0,0,1-1.36-.636l-.2-.145a.811.811,0,0,0-.46-.145H.79a.781.781,0,1,0,0,1.563H2.757a5.8,5.8,0,0,0,2.206.945,2.481,2.481,0,0,0,.478.927A4.329,4.329,0,0,0,3.107,8.013v4.942A1.349,1.349,0,0,0,4.467,14.3h.4V11.81a2.638,2.638,0,0,1,5.276,0V14.3h.4a1.349,1.349,0,0,0,1.36-1.345V8.013a4.347,4.347,0,0,0-1.287-3.071A4.745,4.745,0,0,0,9.577,4.2a2.444,2.444,0,0,0,.46-.927,5.925,5.925,0,0,0,2.206-.945H14.21A.78.78,0,0,0,15,1.544.792.792,0,0,0,14.21.763ZM7.5,1.181A1.436,1.436,0,1,1,6.048,2.616,1.447,1.447,0,0,1,7.5,1.181Z",
    fill: "none",
    stroke: "#002063",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M34.433,57.1A1.537,1.537,0,0,0,32.9,58.633v4.289a1.533,1.533,0,1,0,3.067,0V58.633A1.549,1.549,0,0,0,34.433,57.1Z",
    transform: "translate(-26.933 -46.993)",
    fill: "none",
    stroke: "#002063",
    strokeWidth: 0.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDelivery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_delivery.36c8e9ad.svg";
export { ForwardRef as ReactComponent };